<template>
  <div>
    <div>
      <HomeNew />
    </div>
  </div>
</template>
<script>
import HomeNew from "../../views/pages/dashboard/HomeNew.vue";
export default {
  metaInfo: {
    title: "Focts - Comprehensive Work Management for Productivity and Success",
    titleTemplate: "%s",
    htmlAttrs: {
      lang: "en-US",
    },
    meta: [
      {
        name: "description",
        content:
          "Discover Focts, your all-in-one solution for effective work management. Organize, prioritize, plan, track, and achieve goals with ease. Reduce stress, allocate resources efficiently, and maintain a healthy work-life balance. Elevate your personal and professional success with Focts.",
      },
      {
        name: "keywords",
        content:
          "Focts, work Management, Productivity, Goal Achievement, Stress Reduction, Time Management, Resource Allocation, Organization, Prioritization, Planning, Accountability, Flexibility, Quality Control, Long-Term Planning, Work-Life Balance, Personal Success, Professional Success",
      },
    ],
  },
  components: {
    HomeNew,
  },
  computed: {
    Issuperadmin() {
      if (this.$store.state.account.user) {
        var authuser = JSON.parse(this.$store.state.account.user);
        return authuser.isAdmin;
      } else {
        return false;
      }
    },
  },
};
</script>
